module.exports = __webpack_public_path__ + "img/img_10.0819dd4a.png";